<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__group">
        <div class="footer__group-item">
          <h4 class="footer__title">Videomedi</h4>
          <a href="#" class="footer__link">Como funciona</a>
          <a href="#" class="footer__link">Vantagens</a>
          <a href="#" class="footer__link">FAQ</a>
        </div>
        <div class="footer__group-item">
          <h4 class="footer__title">Institucional</h4>
          <a
            href="https://safetycare.nyc3.digitaloceanspaces.com/politica_privacidade/Pol%C3%ADtica%20de%20Privacidade%20e%20Prote%C3%A7ao%20de%20dados%20-%20Videomedi.pdf"
            class="footer__link"
          >
            Politica de Privacidade
          </a>
          <a href="#" class="footer__link">Atendimento</a>
          <a href="#" class="footer__link">Mapa do site</a>
        </div>
        <div class="footer__group-item">
          <h4 class="footer__title">Dúvidas e sugestões</h4>
          <a href="#" class="footer__link-no-pointer">
            contato@videomedi.com.br
          </a>
        </div>
        <div class="footer__group-item">
          <h4 class="footer__title">Baixe o nosso app</h4>
          <a
            href="https://apps.apple.com/br/app/videomedi/id1626886864"
            class="footer__badge"
          >
            <img src="./../assets/images/apple-badge.svg" alt="" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=br.com.safetysystemtechnology.videomedi"
            class="footer__badge"
          >
            <img src="./../assets/images/google-badge.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.footer__link-no-pointer {
  margin-bottom: 0.4em;
  font-size: 14px;
  font-weight: 400;
  color: #222;
  cursor: default;
}
</style>
